/* eslint-disable no-console */
import {
  Paper,
  Grid,
  ToggleButton,
  ToggleButtonGroup,
  Autocomplete,
  TextField,
  Button as MuiButton,
  Box,
  Typography
} from "@mui/material";
// import logo from "../../../assets/images/logo.svg";
import { useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { httprequest } from "../../../data/api";
import PageLoader from "../../../components/PageLoader";
import useStyles from "../styles";
import Layout from "../../../components/Layout";
import BreadCrumb from "../../../components/BreadCrumb";
import Button from "../../../components/Button";
import InputGroup from "../../../components/FormComponent/InputGroup";
import Modal from "../../../components/Modal";
import Select from "react-select";
import TextAreaGroup from "../../../components/FormComponent/TextAreaGroup";
import { ContentCopy as ContentCopyIcon } from "@mui/icons-material";
import { Icon } from "@iconify/react";
import useWindowSize from "../../../hooks/useWindow";
import Table from "../../../components/Table/Table";
import Badge from "../../../components/Badge";
import { TableSearch } from "../../../components/Table/TableActions";
import PaymentCard from "../../../components/CardCount/PaymentCard";
import { toast } from "react-toastify";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const INVOICE_BY_ID = "/api/v1/invoices/student-invoices";
const MAKE_PAYMENT = "/api/v1/invoices/student-invoices";
const UPLOAD_ENDPOINT = "/api/v1/upload";

const CHIP_COLORS = [
  {
    background: "#007bff",
    text: "#FFFFFF"
  },
  {
    background: "#32b63dff",
    text: "#FFFFFF"
  },
  {
    background: "#edb73aff",
    text: "#000000"
  },
  {
    background: "#06D6A0",
    text: "#000000"
  },
  {
    background: "#118AB2",
    text: "#FFFFFF"
  },
  {
    background: "#9B5DE5",
    text: "#FFFFFF"
  }
];

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error) {
    if (!error.message?.includes("toggle") && !error.stack?.includes("typedCharts")) {
      console.log("Error caught by boundary:", error);
    }
  }

  render() {
    if (this.state.hasError) {
      if (this.state.error?.message?.includes("toggle") ||
          this.state.error?.stack?.includes("typedCharts")) {
        return this.props.children;
      }

      return this.props.fallback;
    }

    return this.props.children;
  }
}
const MyInvoiceOverview = () => {
  const classes = useStyles();
  const { id } = useParams();
  const [aStudentInvoice, setAStudentInvoice] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  const [showPaymentMethodModal, setShowPaymentMethodModal] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [showBankDetailsModal, setShowBankDetailsModal] = useState(false);
  const [selectedBankDetails, setSelectedBankDetails] = useState(null);
  const [transactionData, setTransactionData] = useState([]);
  const width = useWindowSize();
  const isMobile = width < 600;
  const [receiptData, setReceiptData] = useState({
    title: "",
    file: null
  });
  const navigate = useNavigate();
  const [comment, setComment] = useState("");
  const [isProcessingOfflinePayment, setIsProcessingOfflinePayment] = useState(false);
  const [paymentAmount, setPaymentAmount] = useState("");

  // eslint-disable-next-line no-unused-vars
  const [copiedField, setCopiedField] = useState(null);
  const bankAccounts = aStudentInvoice?.offline_payment_methods || [];

  const [selectedBank, setSelectedBank] = useState(
    bankAccounts[0]?.bank_name || null
  );
  const hasBanks = bankAccounts.length > 0;
  const getChipColor = (bankName) => {
    const bankIndex = bankAccounts.findIndex(bank => bank.bank_name === bankName);

    return CHIP_COLORS[bankIndex % CHIP_COLORS.length] || CHIP_COLORS[0];
  };
  const [otherBankValue, setOtherBankValue] = useState(null);
  const topBanks = bankAccounts.slice(0, 3);
  const otherBanks = bankAccounts.slice(3);
  const isOtherBankSelected = selectedBank && !topBanks.some(b => b.bank_name === selectedBank);

  const getChipStyles = (bankName) => {
    const color = getChipColor(bankName);

    return {
      textTransform: "none",
      borderRadius: "100px !important",
      border: "1px solid #ddd !important",
      color: color.text,
      marginRight: "10px",
      marginBottom: "10px",
      backgroundColor: color.background,
      fontWeight: "500",
      fontSize: "14px",
      padding: "8px 16px",
      transition: "all 0.2s ease-in-out",

      "&.Mui-selected": {
        backgroundColor: "#007bff",
        color: "white",
        border: "1px solid #007bff !important",
        "&:hover": {
          backgroundColor: "#0056b3"
        }
      },
      "&:not(.Mui-selected):hover": {
        backgroundColor: color.background,
        opacity: 0.9,
        transform: "translateY(-1px)",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
      }
    };
  };

  const handleBankChipClick = (bank) => {
    setSelectedBankDetails(bank);
    setShowBankDetailsModal(true);
    setCopiedField(null);
  };

  const handleCopy = async (text, field) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedField(field);
      toast.success(`${field === "account_number" ? "Account number" : "Account name"} copied to clipboard!`);

      setTimeout(() => {
        setCopiedField(null);
      }, 2000);
    } catch (err) {
      toast.error("Failed to copy text");
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const validTypes = ["image/jpeg", "image/jpg", "image/png"];
      if (!validTypes.includes(file.type)) {
        toast.error("Please select a JPG or PNG file");

        return;
      }

      if (file.size > 10 * 1024 * 1024) {
        toast.error("File size must be less than 10MB");

        return;
      }

      setReceiptData(prev => ({
        ...prev,
        file
      }));
    }
  };

  const handleRemoveFile = () => {
    setReceiptData(prev => ({
      ...prev,
      file: null
    }));
  };

  const paymentMethods = [
    ...(aStudentInvoice?.online_payment_method?.provider
      ? [{ value: "online_transfer", label: "Online Transfer" }]
      : []
    ),
    ...(aStudentInvoice?.offline_payment_methods?.length > 0
      ? [{ value: "bank_transfer", label: "Bank Transfer" }]
      : []
    ),
    { value: "cash", label: "Cash" }
  ];

  const getInvoiceTransactions = () => {
    httprequest
      .get(`${INVOICE_BY_ID}/${id}/transactions`)
      .then((res) => {
        setTransactionData(res?.data?.data || []);
      }).catch((error) => {
        toast.error(error?.response?.message);
      });
  };

  const getStudentClassInvoice = () => {
    setIsLoading(true);
    httprequest
      .get(`${INVOICE_BY_ID}/${id}`)
      .then((res) => {
        setAStudentInvoice(res?.data?.data);
        setIsLoading(false);
      }).catch(() => {
        setIsLoading(false);
      });
  };

  const processOnlinePayment = async () => {
    if (!aStudentInvoice?.invoice_no) {
      toast.error("Invoice information is missing");

      return;
    }

    if (!paymentAmount || parseFloat(paymentAmount) <= 0) {
      toast.error("Please enter a valid payment amount");

      return;
    }

    const amountToPay = parseFloat(paymentAmount);
    const outstanding = aStudentInvoice?.outstanding || 0;

    if (amountToPay > outstanding) {
      toast.error(`Payment amount cannot exceed outstanding balance of ${outstanding.toLocaleString()}`);

      return;
    }

    setIsProcessingPayment(true);

    try {
      const payload = {
        amount: amountToPay
      };

      const response = await httprequest.post(
        `${MAKE_PAYMENT}/${aStudentInvoice.invoice_no}/pay`,
        payload
      );

      if (response?.data?.data?.redirect_url) {
        toast.success("Payment link generated successfully! Redirecting to payment gateway...");
        setTimeout(() => {
          window.open(response?.data?.data?.redirect_url, "_self");
        }, 1500);
      } else {
        toast.error("Failed to generate payment link. Please try again.");
        setIsProcessingPayment(false);
      }
    } catch (error) {
      setIsProcessingPayment(false);
      toast.error(error?.response?.data?.message);
    }
  };

  const processOfflinePayment = async () => {
    if (paymentAmount === 0 || parseFloat(paymentAmount) <= 0) {
      toast.error("Please enter a valid payment amount");

      return;
    }

    if (!receiptData.file) {
      toast.error("Please upload a receipt");

      return;
    }

    setIsProcessingOfflinePayment(true);

    try {
      const formData = new FormData();
      formData.append("file", receiptData.file);

      const uploadResponse = await httprequest.post(UPLOAD_ENDPOINT, formData);

      if (uploadResponse.status === 200 && uploadResponse.data.data) {
        const upload_id = uploadResponse.data.data[0]?.upload_id;
        const file_url = uploadResponse.data.data[0]?.file_url;

        const paymentPayload = {
          amount: parseFloat(paymentAmount),
          reference: `invoice-${aStudentInvoice.invoice_no}-${Date.now()}`,
          payment_method: selectedPaymentMethod?.label || "Bank Transfer",
          description: comment || `Payment for invoice ${aStudentInvoice.invoice_no}`,
          receipts: [
            {
              file_url,
              upload_id
            }
          ]
        };

        const paymentResponse = await httprequest.post(
          `${MAKE_PAYMENT}/${aStudentInvoice.invoice_no}/transactions`,
          paymentPayload
        );

        toast.success(paymentResponse?.data?.message || "Payment submitted successfully!");
        setShowPaymentMethodModal(false);
        getStudentClassInvoice();
        getInvoiceTransactions();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Payment submission failed");
    } finally {
      setIsProcessingOfflinePayment(false);
    }
  };

  const handleMakePaymentClick = () => {
    setPaymentAmount(aStudentInvoice?.amount_payable?.toString() || "");
    setShowPaymentMethodModal(true);
    setSelectedPaymentMethod("");
  };

  const handlePaymentMethodSelect = () => {
    if (!selectedPaymentMethod) {
      toast.error("Please select a payment method");

      return;
    }

    if (selectedPaymentMethod?.value === "online_transfer") {
      setShowPaymentMethodModal(false);
      processOnlinePayment();
    } else if (selectedPaymentMethod.value === "bank_transfer" || selectedPaymentMethod.value === "cash") {
      processOfflinePayment();
    }
  };

  const handleAmountChange = (e) => {
    const value = e.target.value;

    const rawValue = value.replace(/,/g, "");

    if (rawValue === "" || /^\d*\.?\d*$/.test(rawValue)) {
      setPaymentAmount(rawValue);
    }
  };

  const formatAmountWithCommas = (value) => {
    if (!value) return "";

    const numberValue = value.toString().replace(/,/g, "");

    return numberValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  useEffect(() => {
    const originalConsoleError = console.error;
    console.error = (...args) => {
      if (args[0] && typeof args[0] === "string") {
        if (args[0].includes("toggle") ||
          args[0].includes("typedCharts") ||
          args[0].includes("The above error occurred")) {
          return;
        }
      }
      originalConsoleError.apply(console, args);
    };

    return () => {
      console.error = originalConsoleError;
    };
  }, []);

  useEffect(() => {
    getStudentClassInvoice();
    getInvoiceTransactions();
  }, []);

  const DetailItem = ({ label, value }) => {
    const renderValue = () => {
    // eslint-disable-next-line no-undefined
      if (value === null || value === undefined) return "--/--";

      if (typeof value === "object" && value !== null) {
        return value.name || value.value || "--/--";
      }

      return value;
    };

    return (
      <div className={classes.detailItem}>
        <label>{label}</label>
        <p>{renderValue()}</p>
      </div>
    );
  };

  const columns = [
    {
      name: "Invoice Name",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Invoice Name</p>}
          {row?.invoice_name || "--/--"}
        </>
      )
    },
    {
      name: "Invoice NO",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Invoice NO</p>}
          {row?.invoice_no || "--/--"}
        </>
      )
    },
    {
      name: "Total Amount",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Total Amount</p>}
          {(row?.amount || 0)?.toLocaleString()}
        </>
      )
    },
    {
      name: "Amount Paid",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Amount Paid</p>}
          {(row?.amount_paid || 0)?.toLocaleString()}
        </>
      )
    },
    {
      name: "Status",
      center: "true",
      cell: (row) => (
        <p style={{ display: "flex", flexDirection: "column", margin: 0, marginBlock: 0 }}>
          {isMobile && <p style={{ margin: 0, fontSize: "12px" }}>Status</p>}
          <Badge status={row?.status} />
        </p>
      )
    },
    {
      name: "",
      center: "true",
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button className="table-action-icon" onClick={() => navigate(`/guardian/transaction/${row?.id}`)}>
            <Icon icon="fluent:eye-16-regular" />
          </button>
        </div>
      )
    }
  ];

  const downloadTransactionReceipt = async () => {
    if (!aStudentInvoice) {
      toast.error("No transaction data available");

      return;
    }

    try {
      const receiptContainer = document.createElement("div");
      receiptContainer.style.padding = "20px";
      receiptContainer.style.backgroundColor = "white";
      receiptContainer.style.position = "absolute";
      receiptContainer.style.left = "-9999px";
      receiptContainer.style.top = "0";

      const originalContainer = document.querySelector(".transaction-details-container");
      const clonedContent = originalContainer.cloneNode(true);

      const logoSection = document.createElement("div");
      logoSection.style.textAlign = "center";
      logoSection.style.marginBottom = "20px";
      logoSection.style.borderBottom = "2px solid #f0f0f0";
      logoSection.style.paddingBottom = "20px";

      const receiptTitle = document.createElement("h1");
      receiptTitle.style.margin = "0 0 15px 0";
      receiptTitle.style.color = "#1976d2";
      receiptTitle.style.fontSize = "24px";
      receiptTitle.style.fontWeight = "bold";

      receiptContainer.appendChild(logoSection);
      receiptContainer.appendChild(clonedContent);

      document.body.appendChild(receiptContainer);

      const canvas = await html2canvas(receiptContainer, {
        scale: 1.5,
        useCORS: true,
        logging: false
      });

      document.body.removeChild(receiptContainer);

      const imgData = canvas.toDataURL("image/png");
      // eslint-disable-next-line new-cap
      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 190;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);

      const fileName = `receipt-${aStudentInvoice.invoice_no}.pdf`;
      pdf.save(fileName);
      toast.success("Receipt downloaded successfully!");
    } catch (error) {
      toast.error("Failed to generate receipt");
    }
  };

  return (
    <ErrorBoundary>
      <Layout children={
        <>
          <div className="breadcrumb-container">
            <div>
              <BreadCrumb
                link_one="/guardian/payment"
                link_one_name="Payments"
                active={`${aStudentInvoice?.student?.last_name || "--/--"} ${aStudentInvoice?.student?.first_name || "--/--"} Invoice Overview`}
                description="Details of your invoice"
              />
            </div>
            {aStudentInvoice?.status !== "paid" ? (
              <Button
                variant="primary"
                buttonSize="fluid"
                color="btndefault"
                buttonName="Make Payment"
                onClick={handleMakePaymentClick}
                disabled={isProcessingPayment}
              />) : null }
          </div>
          <Grid container spacing={isMobile ? 1 : 3}>
            <Grid item lg={3} md={6} sm={6} xs={12}>
              <PaymentCard
                title="Total Amount"
                count={`${aStudentInvoice?.total?.toLocaleString() || 0}`}
                icon={<Icon icon="material-symbols-light:payments-outline" />}
              />
            </Grid>
            <Grid item lg={3} md={6} sm={6} xs={12}>
              <PaymentCard
                title="Amount Paid"
                count={`${aStudentInvoice?.amount_paid?.toLocaleString() || 0}`}
                icon={<Icon icon="fluent:wallet-credit-card-48-filled" width="20" height="20" />}
              />
            </Grid>
            <Grid item lg={3} md={6} sm={6} xs={12}>
              <PaymentCard
                title="Outstanding"
                count={`${aStudentInvoice?.outstanding?.toLocaleString() || 0}`}
                icon={<Icon icon="hugeicons:wallet-remove-01" width="20" height="20" />}
              />
            </Grid>
            <Grid item lg={3} md={6} sm={6} xs={12}>
              <PaymentCard
                title="Overpayment"
                count={`${aStudentInvoice?.overpayment?.toLocaleString() || 0}`}
                icon={<Icon icon="hugeicons:wallet-remove-01" width="20" height="20" />}
              />
            </Grid>
          </Grid>
          <div className="page-content margin-top-30">
            {isLoading ? (
              <PageLoader />
            ) : (
              <>
                <div className="transaction-details-container">
                  <Paper elevation={0} className={classes.invoiceContainer}>
                    <header className={classes.invoiceHeader}>
                      <div className={classes.headerLeft}>
                        <h1>Invoice Details</h1>
                        <p>See all information in your Invoice</p>
                      </div>
                      <div className={classes.headerRight}>
                        <span
                          className={classes.statusBadge}
                          style={{
                            backgroundColor:
      aStudentInvoice.status === "paid" ? "#d4edda" :
        aStudentInvoice.status === "partly_paid" ? "#fff3cd" :
          "#f8d7da",
                            color:
      aStudentInvoice.status === "paid" ? "#155724" :
        aStudentInvoice.status === "partly_paid" ? "#856404" :
          "#d9534f"
                          }}
                        >{aStudentInvoice.status || "--/--"}
                        </span>
                        <div className={classes.invoiceNumber}>
                          <small>Invoice Number</small>
                          <span>{aStudentInvoice.invoice_no || "--/--"}</span>
                        </div>
                      </div>
                    </header>

                    <Grid container spacing={3} className={classes.detailsGrid}>
                      <Grid item xs={6} sm={4} md={2}>
                        <DetailItem label="Invoice Name" value={aStudentInvoice?.invoice_name} />
                      </Grid>
                      <Grid item xs={6} sm={4} md={2}>
                        <DetailItem label="Session" value={aStudentInvoice?.session} />
                      </Grid>
                      <Grid item xs={6} sm={4} md={2}>
                        <DetailItem label="Term" value={aStudentInvoice?.term} />
                      </Grid>
                      <Grid item xs={6} sm={4} md={2}>
                        <DetailItem label="Class" value={aStudentInvoice?.class} />
                      </Grid>
                      <Grid item xs={6} sm={4} md={2}>
                        <DetailItem label="Date Created" value={aStudentInvoice?.created_at} />
                      </Grid>
                      <Grid item xs={6} sm={4} md={2}>
                        <DetailItem label="Date Due" value={aStudentInvoice?.due_date} />
                      </Grid>
                    </Grid>

                    <section className={classes.invoiceParties}>
                      <div className={classes.clientInfo}>
                        <p>
                          <strong>
                            {aStudentInvoice?.student ?
                              `${aStudentInvoice?.student?.first_name || ""} ${aStudentInvoice?.student?.last_name || ""}`.trim() || "--/--"
                              : "--/--"
                            }
                          </strong>
                        </p>
                        <p>{aStudentInvoice?.student?.address || "--/--"}</p>
                      </div>
                      <div className={classes.companyInfo}>
                        <p>{aStudentInvoice?.school?.phone || "--/--"}</p>
                        <p>{aStudentInvoice?.school?.email || "--/--"}</p>
                        <p>{aStudentInvoice?.school?.address || "--/--"}</p>
                      </div>
                    </section>
                    <section className={classes.invoiceTableSection}>
                      <table className={classes.invoiceTable}>
                        <thead>
                          <tr>
                            <th>Service Description</th>
                            <th>Qty</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {aStudentInvoice?.fee_items && aStudentInvoice?.fee_items.length > 0 ? (
                            aStudentInvoice?.fee_items?.map((item) => (
                              <tr key={item.id}>
                                <td>{item.item || "--/--"}</td>
                                <td>1</td>
                                <td>{(item.amount || 0)?.toLocaleString()}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="3" style={{ textAlign: "center" }}>No items found</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </section>

                    <section className={classes.summaryContainer}>
                      <div className={classes.summaryWrapper}>
                        <div className={classes.summaryRow}>
                          <span>SUB TOTAL</span>
                          <span>{(aStudentInvoice?.total || 0)?.toLocaleString()}</span>
                        </div>
                        <div className={classes.summaryRow}>
                          <span>TAX</span>
                          <span>0</span>
                        </div>
                        <div className={classes.summaryRow}>
                          <span>DISCOUNT</span>
                          <span>{(aStudentInvoice?.discount_value || 0)?.toLocaleString()}</span>
                        </div>
                        <div className={`${classes.summaryRow} ${classes.grandTotal}`}>
                          <span>AMOUNT PAYABLE</span>
                          <span>{(aStudentInvoice?.amount_payable || 0)?.toLocaleString()}</span>
                        </div>
                      </div>
                    </section>

                    <footer className={classes.invoiceFooter}>
                      <button className={classes.printButton} onClick={downloadTransactionReceipt}>
                        <Icon icon="mdi-light:printer" width="24" height="24" />
                        <span>Print Invoice</span>
                      </button>
                    </footer>
                  </Paper>
                </div>
                <div className="white_bg">
                  <h3 style={{ textAlign: "left" }}>Transaction History</h3>
                  <Table
                    data={transactionData}
                    columns={columns}
                    subHeader={true}
                    pagination
                    subHeaderComponent={
                      <div className="action_div">
                        <TableSearch
                          placeholder="Search here..."
                        />
                      </div>}
                  />
                </div>
              </>
            )}
          </div>

          <Modal
            title="Select Payment Method"
            subtitle="Choose how you would like to make your payment"
            modalContent={
              <Grid container spacing={2} className="input-padding">
                <Grid item xs={12}>
                  <div className="multiple-select">
                    <p>Select Payment Method</p>
                    <Select
                      label="Payment Method"
                      options={paymentMethods}
                      value={selectedPaymentMethod}
                      onChange={(selectedOption) => setSelectedPaymentMethod(selectedOption)}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 })
                      }}
                      menuPortalTarget={document.body}
                      menuPosition="absolute"
                      menuShouldScrollIntoView={false}
                      isSearchable={false}
                    />
                  </div>
                </Grid>

                {selectedPaymentMethod?.value === "online_transfer" && (
                  <>
                    <Grid item xs={12}>
                      <InputGroup
                        label="Amount to Pay"
                        inputType="text"
                        inputName="amount"
                        placeHolder="Amount"
                        onChange={handleAmountChange}
                        value={formatAmountWithCommas(paymentAmount)}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <div style={{ padding: "15px", backgroundColor: "#f8f9fa", borderRadius: "8px", margin: 0 }}>
                        <p>You will be redirected to a secure payment gateway to complete your payment.</p>
                      </div>
                    </Grid>
                  </>
                )}
                {selectedPaymentMethod?.value === "cash" && (
                  <>
                    <Grid item xs={12}>
                      <InputGroup
                        label="Amount Paid"
                        inputType="text"
                        inputName="amount"
                        placeHolder="Amount"
                        value={formatAmountWithCommas(paymentAmount)}

                      />
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <p className="text-align-left no-margin-block">
                        <strong>Upload Teller</strong>
                        <span className="input-required">*</span>
                      </p>
                      <div className={classes.pickcontainer}>
                        <input
                          type="file"
                          required
                          className={classes.picker}
                          onChange={handleFileChange}
                          name="file"
                          accept=".png, .jpg, .jpeg"
                        />

                        <div className={classes.uploadflex}>
                          <div>
                            <Icon
                              icon="icon-park-outline:upload-two"
                              className={classes.uploadicon}
                            />
                          </div>
                          {receiptData.file?.name ? (
                            <div>
                              <h2 className={classes.uploadtitle}>
                                {receiptData.file?.name}
                              </h2>
                              <p className={classes.uploadsubtitle}>
                                {(receiptData.file.size / (1024 * 1024)).toFixed(2)} MB
                              </p>
                            </div>
                          ) : (
                            <div>
                              <p className={classes.uploadtitle}>
                                              Tap to Upload
                              </p>
                              <p className={classes.uploadsubtitle}>
                                              JPG, PNG | 10MB max.
                              </p>
                            </div>
                          )}
                        </div>
                        <div className={classes.rightpicker}>
                          {receiptData.file?.name ? (
                            <div
                              className={classes.uploadbutton}
                              onClick={handleRemoveFile}
                            >
                              <Icon icon="zondicons:minus-solid" /> Remove File
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </Grid>
                  </>
                )}

                {selectedPaymentMethod?.value === "bank_transfer" && (
                  !hasBanks ? (
                    <div style={{
                      padding: "15px",
                      backgroundColor: "#fff3cd",
                      borderRadius: "8px",
                      border: "1px solid #ffeaa7",
                      textAlign: "center",
                      marginTop: "10px"
                    }}
                    >
                      <Typography variant="body2" sx={{ color: "#856404" }}>
              No bank accounts available for transfer. Please contact the school for bank details.
                      </Typography>
                    </div>
                  ) : (
                    <>
                      <Grid item xs={12}>
                        <div className="multiple-select">
                          <p>Select Bank</p>
                          <ToggleButtonGroup
                            value={isOtherBankSelected ? "other" : selectedBank}
                            exclusive
                            onChange={(event, newBank) => {
                              if (newBank !== null) {
                                setSelectedBank(newBank);
                                if (newBank !== "other") {
                                  setOtherBankValue(null);
                                }
                              }
                            }}
                            aria-label="bank selection"
                            sx={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "10px",
                              "& .MuiToggleButtonGroup-grouped": { border: 0, "&.Mui-disabled": { border: 0 } }
                            }}
                          >
                            {topBanks.map((bank) => (
                              <ToggleButton
                                key={bank.id}
                                onClick={() => handleBankChipClick(bank)}
                                value={bank.bank_name}
                                sx={getChipStyles(bank.bank_name)}
                              >
                                {bank.bank_name}
                              </ToggleButton>
                            ))}

                            {otherBanks.length > 0 && (
                              <ToggleButton
                                value="other"
                                aria-label="other bank"
                                sx={{
                                  textTransform: "none",
                                  borderRadius: "100px !important",
                                  border: "1px solid #ddd !important",
                                  color: "#ffffffff",
                                  marginRight: "10px",
                                  marginBottom: "10px",
                                  backgroundColor: "#6c757d",
                                  "&:not(.Mui-selected):hover": {
                                    backgroundColor: "#6c757d",
                                    opacity: 0.8
                                  }
                                }}
                              >
              Other Bank
                              </ToggleButton>
                            )}
                          </ToggleButtonGroup>
                        </div>
                      </Grid>

                      {(isOtherBankSelected || selectedBank === "other") && (
                        <Grid item xs={12}>
                          <Autocomplete
                            options={otherBanks.map((bank) => bank.bank_name)}
                            value={otherBankValue}
                            onChange={(event, newValue) => {
                              setOtherBankValue(newValue);
                              setSelectedBank(newValue);

                              if (newValue) {
                                const selectedBankObj = otherBanks.find(bank => bank.bank_name === newValue);
                                if (selectedBankObj) {
                                  handleBankChipClick(selectedBankObj);
                                }
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Search for your bank"
                                variant="outlined"
                              />
                            )}
                          />
                        </Grid>
                      )}
                      <Grid item xs={12}>
                        <InputGroup
                          label="Amount Paid"
                          inputType="text"
                          inputName="amount"
                          placeHolder="Amount"
                          value={formatAmountWithCommas(paymentAmount)}
                          onChange={handleAmountChange}
                        />
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <p className="text-align-left no-margin-block">
                          <strong>Upload Receipt</strong>
                          <span className="input-required">*</span>
                        </p>
                        <div className={classes.pickcontainer}>
                          <input
                            type="file"
                            required
                            className={classes.picker}
                            onChange={handleFileChange}
                            name="file"
                            accept=".png, .jpg, .jpeg"
                          />

                          <div className={classes.uploadflex}>
                            <div>
                              <Icon
                                icon="icon-park-outline:upload-two"
                                className={classes.uploadicon}
                              />
                            </div>
                            {receiptData.file?.name ? (
                              <div>
                                <h2 className={classes.uploadtitle}>
                                  {receiptData.file?.name}
                                </h2>
                                <p className={classes.uploadsubtitle}>
                                  {(receiptData.file.size / (1024 * 1024)).toFixed(2)} MB
                                </p>
                              </div>
                            ) : (
                              <div>
                                <p className={classes.uploadtitle}>
                Tap to Upload
                                </p>
                                <p className={classes.uploadsubtitle}>
                JPG, PNG | 10MB max.
                                </p>
                              </div>
                            )}
                          </div>
                          <div className={classes.rightpicker}>
                            {receiptData.file?.name ? (
                              <div
                                className={classes.uploadbutton}
                                onClick={handleRemoveFile}
                              >
                                <Icon icon="zondicons:minus-solid" /> Remove File
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </Grid>
                      <Grid item xs={12}>
                        <TextAreaGroup
                          label="Comment"
                          inputName="comment"
                          margin="normal"
                          placeholder=""
                          value={comment}
                          onChange={(e) => setComment(e.target.value)}
                        />
                      </Grid>
                    </>
                  )
                )}
              </Grid>
            }
            modalFooter={
              <div className="flex gap-10">
                <Button
                  variant="primary"
                  buttonSize="full"
                  color="btndefault"
                  buttonName={selectedPaymentMethod?.value === "online_transfer" ? "Make Payment" : "Proceed"}
                  onClick={handlePaymentMethodSelect}
                  disabled={!selectedPaymentMethod || (selectedPaymentMethod?.value !== "online_transfer" && !paymentAmount) || isProcessingOfflinePayment}
                  isLoading={isProcessingPayment || isProcessingOfflinePayment}
                />
              </div>
            }
            isopen={showPaymentMethodModal}
            closeModal={() => setShowPaymentMethodModal(false)}
          />

          <Modal
            title="Copy Account details"
            subtitle="Choose your preferred payment method and complete your transaction"
            isopen={showBankDetailsModal}
            closeModal={() => {
              setShowBankDetailsModal(false);
              setOtherBankValue(null);
              setSelectedBank(bankAccounts[0]?.bank_name || null);
            }}
            modalContent={
              <Box sx={{ backgroundColor: "#f4f5f7",
                padding: "5px 15px",
                borderRadius: "6px" }}
              >
                <Box sx={{
                  display: "grid",
                  gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr 1fr" },
                  gap: "20px",
                  borderBottom: "1px dashed #CCCCCC",
                  paddingBottom: "15px"
                }}
                >
                  <div>
                    <Typography variant="caption" sx={{ color: "#6c757d", textTransform: "uppercase" }}>
                    Bank Name
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 600, color: "#000" }}>
                      {selectedBankDetails?.bank_name}
                    </Typography>
                  </div>
                  <div>
                    <Typography variant="caption" sx={{ color: "#6c757d", textTransform: "uppercase" }}>
                    Account Number
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 600, color: "#000" }}>
                      {selectedBankDetails?.account_number}
                    </Typography>
                  </div>
                  <div>
                    <Typography variant="caption" sx={{ color: "#6c757d", textTransform: "uppercase" }}>
                    Account Name
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 600, color: "#000" }}>
                      {selectedBankDetails?.account_name}
                    </Typography>
                  </div>
                </Box>

                <MuiButton
                  startIcon={<ContentCopyIcon />}
                  onClick={() => handleCopy(selectedBankDetails?.account_number)}
                  sx={{
                    textTransform: "none",
                    color: "#007bff",
                    padding: "8px 0",
                    "&:hover": { backgroundColor: "transparent" }
                  }}
                >
                Copy Account Number
                </MuiButton>
              </Box>
            }
            modalFooter={
              <Button
                variant="primary"
                buttonSize="full"
                color="btndefault"
                buttonName="Close"
                onClick={() => {
                  setShowBankDetailsModal(false);
                  setOtherBankValue(null);
                  setSelectedBank(bankAccounts[0]?.bank_name || null);
                }}
              />
            }
          />

          {/* <ToastContainer /> */}
        </>
      }
      />
    </ErrorBoundary>
  );
};

export default MyInvoiceOverview;
